<template>
  <div>
    <section class="fxt-template-layout10">
      <v-container fluid class="pa-0">
        <v-layout row wrap>
          <v-flex md6 class="col-12 fxt-bg-img flex-b" data-bg-image="../../../static/img/bg14-l.jpg">
            <div class="fxt-header">
                <div>
                    <h1 class="black--text">{{$t('header.analyst')}} </h1>
                </div>
                <div>
                    <p class="black--text">{{$t('header.paidTitle')}}</p>
                </div>
            </div>
          </v-flex>
          <v-flex md6 class="col-12 fxt-bg-color">
            <div class="fxt-content">                            
                <div class="fxt-form">                               
                  <h2>{{$t("password.title")}}</h2>
                     <!--**********************   Form   ************************************************** -->
                      <Form ref="formInline" :model="formInline" :rules="ruleInline">
                        <FormItem prop="regEmail">
                          <Input v-model="formInline.regEmail" placeholder="E-mail Address" v-on:input="showButton"></Input>
                        </FormItem>
                        <Checkbox v-model="isAgree"><span class="ml-2">{{$t("password.agreeMsg")}}</span></Checkbox>
                        <span v-show="isShowAgreeMessage">{{$t("password.agreeHint")}}</span>
                        <FormItem class="mt-3">
                          <div v-show="isDisabled">
                            <v-btn disabled @click="handleSubmit('formInline')">{{$t("password.resetButton")}}</v-btn>
                          </div>
                          <div v-show="!isDisabled" class="mt-3 mb-3">
                            <v-btn class="primary" dark @click="handleSubmit('formInline')">{{$t("password.resetButton")}}</v-btn>
                          </div>
                        </FormItem>
                      </Form>
                   
                    <div class="font-14">
                      <span>{{$t("header.accountHint")}}?</span>
                      <span @click="gotoRegister" class="primary--text pointer mr-2">{{$t("header.signUp")}}</span>
                    </div>
                </div> 
                <div class="fxt-footer">
                    <ul class="fxt-socials">
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBots_" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-twitter fxt-transformY-50 fxt-transition-delay-7">
                            <a href="https://twitter.com/ioBotsPro" title="twitter"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="fxt-linkedin fxt-transformY-50 fxt-transition-delay-9">
                            <a href="https://t.me/iob_llc" title="Telegram"><i class="fab fa-telegram-plane"></i></a>
                        </li>
                    </ul>
                </div>
              </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>  
  </div>
</template>
<script>
import Md5 from "js-md5";
import config from "../../config.js";
import $ from 'jquery';
export default {
  data() {
    return {
      isDisabled: false, //是否禁用按钮
      isAgree: false, //是否同意禁用账户
      isShowAgreeMessage: false, //是否显示同意信息
      domainName: config.ip,
      formInline: {
        regEmail: ""
      },
      ruleInline: {
        regEmail: [
          {
            required: true,
            message: this.$t("password.requiredMessage.regEmail"),
            trigger: "change"
          },
          {
            type: "email",
            message: this.$t("password.requiredMessage.type"),
            trigger: "change"
          }
        ]
      }
    };
  },
  mounted() {
    this.background();
    //浏览器窗口发生变化时同时变化DIV高度
    // window.onresize=this.autodivheight();
  },
  methods: {
    background(){
        $("[data-bg-image]").each(function() {
          var img = $(this).data("bg-image");
            $(this).css({
              backgroundImage: "url(" + img + ")"
            });
        })
    },
    //自动获得div高度
    // autodivheight(){
    //     //函数：获取尺寸
    //     //获取浏览器窗口高度
    //     var winHeight=0;
    //     if (window.innerHeight){
    //         winHeight = window.innerHeight;
    //     }else if ((document.body) && (document.body.clientHeight)){
    //         winHeight = document.body.clientHeight;
    //     }//通过深入Document内部对body进行检测，获取浏览器窗口高度
    //     if (document.documentElement && document.documentElement.clientHeight){
    //         winHeight = document.documentElement.clientHeight;
    //     }
    //     //DIV高度为浏览器窗口的高度:winHeight - 66
    //     document.getElementById("content").style.height= winHeight +"px";
    // },
    //跳转到注册页面
    gotoRegister: function() {
      this.$router.push({ name: "register" });
    },
    //显示按钮
    showButton: function() {
      this.isDisabled = false;
    },
    //按钮
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (this.isAgree) {
          this.isShowAgreeMessage = false;
        }
        if (valid) {
          if (this.isAgree) {
            this.isShowAgreeMessage = false;
            //将按钮设置为禁用
            this.isDisabled = true;
            //校验成功后，发送请求
            let url = config.baseUrl + "user/open/sendEmailEditPwd";
            this.$http.post(url, this.formInline).then(
              function(successData) {
                let data = successData.data;
                if (data.resCode == 0) {
                  this.$Message.success(this.$t("password.sendMessage"));
                } else if (data.resCode == -1) {
                  this.$Message.error(this.$t("password.notRegisteredMessage"));
                } else if (data.resCode == -10001) {
                  this.$Message.error(this.$t("password.failMessage"));
                }
              },
              function(errorData) {
                this.$Message.error(this.$t("common.fail"));
              }
            );
          } else {
            this.isShowAgreeMessage = true;
          }
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// Password.vue?068606e2